import React, { PropsWithChildren } from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { Button } from '../../mui';

import clsx from 'clsx';
import { ConfirmationSeverity, ConfirmationStore, useConfirmationStore } from '../../../store';

import styles from './ConfirmationDialog.module.scss';

interface IconProps {
   className: string;
}

const Icon = React.memo(({ className }: IconProps) => {
   return (
      <div className={clsx(styles.icon, className)}>
         <div className={styles.line} />
         <div className={styles.line} />
      </div>
   );
});

export interface ConfirmationDialogProps extends PropsWithChildren<any> {
   description?: string;
   icon?: ConfirmationSeverity | null;
   onAction: ((result: boolean) => void) | undefined;
   open: boolean;
   title?: string;
}

const ConfirmationDialog = React.memo(
   ({
      description = '',
      icon = ConfirmationSeverity.SUCCESS,
      onAction = undefined,
      open,
      title = '',
      children,
   }: ConfirmationDialogProps): React.ReactNode => {
      const confirmation = useConfirmationStore((state: ConfirmationStore) => ({
         toggle: state.toggle,
      }));

      function handleAction(result: boolean) {
         confirmation.toggle(false);

         if (onAction) {
            onAction(result);
         }
      }

      return (
         <Dialog open={open} fullWidth>
            <div className={styles.iconWrapper}>
               <Icon className={styles[icon || ConfirmationSeverity.SUCCESS]} />
            </div>

            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
               <DialogContentText>
                  <Typography dangerouslySetInnerHTML={{ __html: description }} />
               </DialogContentText>
               {children ? children : null}
            </DialogContent>
            <DialogActions>
               <Button onClick={handleAction.bind(null, false)} color="secondary">
                  Cancel
               </Button>
               {onAction ? (
                  <Button variant="contained" onClick={handleAction.bind(null, true)} color="primary" autoFocus>
                     Confirm
                  </Button>
               ) : null}
            </DialogActions>
         </Dialog>
      );
   },
);

export { ConfirmationDialog };
export default ConfirmationDialog;
